"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldStable = exports.FormField = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("../../../types/react");
const Wrapper_1 = require("./Wrapper");
/** @deprecated Use FormFieldStable */
exports.FormField = (0, react_2.withRef)((props, ref) => {
    const { prefix, addon, addonIcon, info, error, label, modificators, type = 'text', addonWidth = '46px', required, hidden, ...restProps } = props;
    const style = { '--addon-width': addonWidth };
    const formFieldWrapperProps = {
        label,
        error,
        info,
        addon: addon !== null && addon !== void 0 ? addon : undefined,
        addonIcon,
        prefix,
        modificators,
        required,
        style,
        inputSlot: (react_1.default.createElement("input", { ...restProps, ref: ref, type: type })),
    };
    if (hidden)
        return null;
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { ...formFieldWrapperProps }));
});
const FormFieldStable = (props) => {
    const { nativeValue, onChange, onFocus, autoFocus, autoComplete = 'off', name, inputMode, type = 'text', prefix, prefixIcon, addon, addonIcon, placeholder, label, info, error, required, hidden, disabled, additionClassNames, modificators, } = props;
    const formFieldWrapperProps = {
        label,
        error,
        info,
        prefix,
        prefixIcon,
        addon,
        addonIcon,
        required,
        additionClassNames,
        modificators,
        inputSlot: (react_1.default.createElement("input", { value: nativeValue, onChange: onChange, onFocus: onFocus, autoFocus: autoFocus, autoComplete: autoComplete, name: name, inputMode: inputMode, type: type, placeholder: placeholder, disabled: disabled })),
    };
    if (hidden)
        return null;
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { ...formFieldWrapperProps }));
};
exports.FormFieldStable = FormFieldStable;
//# sourceMappingURL=index.js.map